export const SportbetCurrency = "$";
export const SportbetLink = "https://www.sportsbet.com.au/";
export const SportbetAgeLimit = 18;

export const SportsbetMultiBuilder = "https://ad.doubleclick.net/ddm/clk/574613126;383621573;i";
export const SportsbetMultiH2HOdds = "https://ad.doubleclick.net/ddm/clk/574613132;383622149;f";
export const SportsbetMultiH2HBTYB = "https://ad.doubleclick.net/ddm/clk/574613132;383622152;z";
export const SportsbetMultiSplash = "https://ad.doubleclick.net/ddm/clk/582727752;391188119;v";
